import type { FlowIdentityProviderAPI } from './identityProvider';

export type ReleaseEnvironment = 'Development' | 'Test' | 'Production';

export interface ReleaseFilter {
    environmentId?: string | null;
    fromDateTimeOffset?: Date | null;
    searchTerm?: string;
    environmentclassificationtypes?: ReleaseEnvironment[];
}

export interface ReleaseAPI {
    id: string;
    name: string;
    tenantId: string;
    summary: string;
    flows: ReleaseFlowAPI[];
    themes: ReleaseThemeAPI[];
    currentEnvironmentId: string;
    canRollback: boolean;
    lastDeployed: string | null;
    createdAt: string;
    createdBy: string;
    updatedAt: string;
    updatedBy: string;
}

export interface ReleaseFlowAPI {
    name: string;
    summary: string;
    releaseId: string;
    flowId: string;
    themeId?: string;
    versionId: string;
    tenantId: string;
    createdDate?: string;
    createdBy?: string;
    updatedAt?: string;
    updatedBy?: string;
    globalAuthenticationType: string;
    identityProvider: FlowIdentityProviderAPI | null;
}

export interface ReleaseThemeAPI {
    name: string;
    summary: string;
    releaseId: string;
    themeId: string;
    versionId: string;
    tenantId: string;
    createdDate?: string;
    createdBy?: string;
    updatedAt?: string;
    updatedBy?: string;
}

export type ReleaseElementAPI = ReleaseFlowAPI | ReleaseThemeAPI;

/**
 * Type guard to check if a release element is a ReleaseFlowAPI
 * @param item - The release element to check
 * @returns true if the item is a ReleaseFlowAPI, false if it's a ReleaseThemeAPI
 */
export function isReleaseFlowAPI(item: ReleaseElementAPI): item is ReleaseFlowAPI {
    return 'flowId' in item && typeof (item as ReleaseFlowAPI).flowId === 'string';
}
